import React from "react";
import * as Styles from "./UscCarDeliveryConfigureDestination.styles";
import Text from "../../../../../shared-components/lexus/styles/atoms/Text";
import Button from "../../../../../shared-components/lexus/styles/atoms/Button";
import Icon from "../../../../../shared-components/lexus/styles/atoms/Icon";
import type { UscCarDeliveryBaseConfig } from "../../../../utils/carDeliveryUtils";
import { UscLabel } from "../../../../utils/labels";

type CarDeliverySelectedDestinationCardProps = {
    removeDeliveryLocation: () => void;
    address: UscCarDeliveryBaseConfig["address"] | undefined;
    dealerName?: string; // If not supplied, we assume this is a home delivery, and use a label instead
};

const CarDeliverySelectedDestinationCard = ({
    removeDeliveryLocation,
    address,
    dealerName,
}: CarDeliverySelectedDestinationCardProps): JSX.Element | null => {
    if (!address) return null;

    return (
        <Styles.Card>
            <Styles.CardHeader>
                <Text variant="paragraph-body-regular">
                    {dealerName || <UscLabel label="uscCarDeliverySelectDestinationOptionHome" />}
                </Text>
                <Button variant="clean" onClick={() => removeDeliveryLocation()}>
                    <Icon variant="trash" />
                </Button>
            </Styles.CardHeader>
            {address.address}
            <br />
            {address.zip} {address.city}
        </Styles.Card>
    );
};

export default CarDeliverySelectedDestinationCard;
